var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.HasPermission(_vm.PermissionList.Marketing_Finance)
    ? _c(
        "div",
        { staticClass: "main" },
        [
          _c("h3", [_vm._v("Cost")]),
          _c(
            "b-row",
            { staticClass: "align-items-center mb-4" },
            [
              _c("b-col", [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-end align-items-center",
                  },
                  [
                    !_vm.$route.fullPath.includes("view")
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-modal",
                                rawName: "v-b-modal.modal-add-cost",
                                modifiers: { "modal-add-cost": true },
                              },
                            ],
                            attrs: { variant: "primary" },
                          },
                          [_vm._v(" Add Cost ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mb-4 align-items-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Search costs..." },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                ],
                1
              ),
              _c("b-col", { staticClass: "text-right", attrs: { md: "8" } }, [
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(
                    " Showing " +
                      _vm._s(_vm.filteredCosts.length) +
                      " of " +
                      _vm._s(_vm.totalCount) +
                      " costs "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm.filteredCosts.length === 0 && !_vm.loading
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c(
                            "b-card",
                            [
                              _c(
                                "b-card-body",
                                { staticClass: "text-center" },
                                [_c("h2", [_vm._v("No costs available")])]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.loading
                    ? _c(
                        "div",
                        { staticClass: "text-center my-4" },
                        [
                          _c("b-spinner", {
                            attrs: { label: "Loading costs..." },
                          }),
                        ],
                        1
                      )
                    : _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          items: _vm.paginatedCosts,
                          fields: _vm.fields,
                          filter: _vm.filter,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(contentName)",
                              fn: function (data) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.contentName
                                          ? data.item.contentName
                                          : "No Content"
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "cell(actions)",
                              fn: function (data) {
                                return [
                                  !_vm.$route.fullPath.includes("view")
                                    ? _c(
                                        "b-dropdown",
                                        {
                                          attrs: {
                                            id: "actions-dropdown",
                                            variant: "link",
                                            size: "sm",
                                            text: "Actions",
                                            right: "",
                                            "no-caret": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        icon: "MoreVerticalIcon",
                                                        size: "16",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editCost(data.item)
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                staticClass: "mr-50",
                                                attrs: {
                                                  icon: "EditIcon",
                                                  size: "16",
                                                },
                                              }),
                                              _vm._v(" Edit "),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteCost(
                                                    data.item.costId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                staticClass: "mr-50",
                                                attrs: {
                                                  icon: "TrashIcon",
                                                  size: "16",
                                                },
                                              }),
                                              _vm._v(" Delete "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2670789334
                        ),
                      }),
                  !_vm.loading
                    ? _c("b-pagination", {
                        staticClass: "my-2",
                        attrs: {
                          "per-page": _vm.perPage,
                          "total-rows": _vm.filteredCosts.length,
                          align: "center",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-add-cost",
                title: _vm.isEditing ? "Edit Cost" : "Add Cost",
                "hide-footer": "",
                size: "lg",
                centered: "",
              },
              on: { hidden: _vm.resetForm },
            },
            [
              _c(
                "b-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.validateAndSubmit($event)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Name",
                                "label-for": "cost_category",
                              },
                            },
                            [
                              _c("b-form-input", {
                                class: { "is-invalid": !_vm.isCategoryValid },
                                attrs: {
                                  id: "cost_category",
                                  placeholder: "Name",
                                },
                                on: { blur: _vm.validateCategory },
                                model: {
                                  value: _vm.newCost.category,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newCost, "category", $$v)
                                  },
                                  expression: "newCost.category",
                                },
                              }),
                              !_vm.isCategoryValid
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [_vm._v("Name is required")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Description",
                                "label-for": "cost_description",
                              },
                            },
                            [
                              _c("b-form-input", {
                                class: {
                                  "is-invalid": !_vm.isDescriptionValid,
                                },
                                attrs: {
                                  id: "cost_description",
                                  placeholder: "Description",
                                },
                                on: { blur: _vm.validateDescription },
                                model: {
                                  value: _vm.newCost.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newCost, "description", $$v)
                                  },
                                  expression: "newCost.description",
                                },
                              }),
                              !_vm.isDescriptionValid
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [_vm._v("Description is required")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Amount",
                                "label-for": "cost_amount",
                              },
                            },
                            [
                              _c("b-form-input", {
                                class: { "is-invalid": !_vm.isAmountValid },
                                attrs: {
                                  type: "number",
                                  id: "cost_amount",
                                  placeholder: "Amount",
                                },
                                on: { blur: _vm.validateAmount },
                                model: {
                                  value: _vm.newCost.amount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newCost, "amount", $$v)
                                  },
                                  expression: "newCost.amount",
                                },
                              }),
                              !_vm.isAmountValid
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [_vm._v("Amount must be a positive number")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Date",
                                "label-for": "cost_date",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                class: { "is-invalid": !_vm.isDateValid },
                                attrs: {
                                  id: "cost_date",
                                  min: _vm.currentDate,
                                },
                                on: { input: _vm.validateDate },
                                model: {
                                  value: _vm.newCost.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newCost, "date", $$v)
                                  },
                                  expression: "newCost.date",
                                },
                              }),
                              !_vm.isDateValid
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [_vm._v("Date is required")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-end",
                          attrs: { md: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            { attrs: { type: "submit", variant: "primary" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isEditing ? "Update Cost" : "Add Cost"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }